import { render, staticRenderFns } from "./initialConfigPage.vue?vue&type=template&id=8354ae54&scoped=true"
import script from "./initialConfigPage.vue?vue&type=script&lang=js"
export * from "./initialConfigPage.vue?vue&type=script&lang=js"
import style0 from "./initialConfigPage.vue?vue&type=style&index=0&id=8354ae54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8354ae54",
  null
  
)

export default component.exports